import { actions } from '../../utils/constants';

export const asyncFetchTemplateTestToManage = ({ testId }) => ({
    type: actions.ASYNC_FETCH_TEMPLATE_TEST_TO_MANAGE,
    payload: { testId },
});

export const asyncUpdateTemplateTestToManage = ({
    testId,
    labelTest,
    maxDuration,
    minOptions,
    maxOptions,
    percentual,
    amountQuestions,
    questionsAddeds,
    questionsRemoveds,
}) => ({
    type: actions.ASYNC_UPDATE_TEMPLATE_TEST,
    payload: {
        testId,
        labelTest,
        maxDuration,
        minOptions,
        maxOptions,
        percentual,
        amountQuestions,
        questionsAddeds,
        questionsRemoveds,
    },
});

export const changeTemplateTestToManage = payload => ({
    type: actions.CHANGE_TEMPLATE_TEST_TO_MANAGE,
    payload: payload,
});



// WEBPACK FOOTER //
// ./src/components/manage-template-test/manage-template-test.actions.js